import { useMemo } from 'react';

import ContractorCard from '../Cards/ContractorCard';
import Icon from '../../Atoms/Icon/Icon';
import bem from '../../../utils/bem';
import { closeModalHandler } from '../../../utils/handleModalActions';

const SelectedContractors = ({
  contractors,
  ctaLink,
  onRemove,
  contratorAddLink,
}) => {
  const componentBaseClass = 'm-selected-contractors';
  const ctaText = Drupal.t('Add another contractor');
  const contractorsSpot = useMemo(() => {
    const items = [undefined, undefined, undefined];
    if (contractors) {
      contractors.forEach(function (contractor, i) {
        items[i] = contractor;
      });
    }
    return items;
  }, [contractors]);

  const CtaIcon = <Icon iconName="plus" width={16} height={16} />;
  const contractorLink = (e) => {
    if (contratorAddLink) {
      window.location.href = contratorAddLink;
    } else {
      closeModalHandler(e, 'contractors-tray-opened');
    }
  };
  const Cta = () =>
    ctaLink ? (
      <a href={ctaLink} className={bem('add-btn', [], componentBaseClass, [])}>
        {ctaText} {CtaIcon}
      </a>
    ) : (
      <button
        type="button"
        className={bem('add-btn', [], componentBaseClass, [])}
        onClick={contractorLink}
      >
        {ctaText} {CtaIcon}
      </button>
    );
  const contractorsList = contractorsSpot.map((contractor, i) =>
    contractor ? (
      <ContractorCard
        contractorData={contractor}
        isSmall
        showRemove
        key={contractor.id}
        className={bem('card', [], componentBaseClass)}
        onRemove={() => onRemove(contractor.id)}
        showDefaultImage
      />
    ) : (
      <Cta key={`cta-btn-${i}`} />
    ),
  );

  return (
    <div className={bem('list', [], componentBaseClass)}>{contractorsList}</div>
  );
};

export default SelectedContractors;
